// add a van image in assets

import { IconArrowUpRight } from "@tabler/icons-react";
import { useFetchFleetSummary } from "../../../apis/dashboardApis";
import { useNavigate } from "react-router-dom";
import { SummaryPeriod } from "../../../apis/dashboardApis";

export default function FleetSummary({
  summaryType,
  startDate,
  endDate,
}: {
  summaryType?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) {
  const { data } = useFetchFleetSummary({
    type: summaryType,
    startDate,
    endDate,
  });

  const fleetData = [
    { label: "Total Vehicles", value: data?.totalVehicles ?? 0 },
    { label: "Assigned", value: data?.assignedVehicles ?? 0 },
    { label: "Not Assigned", value: data?.unassignedVehicles ?? 0 },
    { label: "Vehicle Request", value: data?.vehicleRequest ?? 0 },
  ];
  const navigate = useNavigate();
  return (
    // <div className="rounded-3xl bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] p-6  gap-6 items-start h-full">
    <div className="rounded-3xl bg-white shadow-sm p-6  gap-6 items-start h-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className=" text-xl font-semibold text-[#212121]">
          Fleet Summary
        </h2>
      </div>

      <div className="flex flex-row items-center justify-center  2xl:space-x-10 space-x-10 ">
        <div className=" flex-shrink-0">
          {fleetData.map((item) => (
            <div
              key={item.label}
              className=" 2xl:w-40 w-52 hover:bg-[#FBD037] p-4 rounded-2xl text-center flex flex-col items-center justify-center cursor-pointer "
            >
              <p className="2xl:text-5xl text-4xl font-light">{item.value}</p>
              <p className="text-sm text-[#212121]/60">{item.label}</p>
            </div>
          ))}
        </div>

        <div className="w-full">
          <img src=".\img\fleet-vechile.png" alt="van" className="w-full" />
        </div>
      </div>
    </div>
  );
}
